/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import { auth } from "../firebase";
import { onAuthStateChanged, User } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

// --------------------------------------------------
// ROUTES
// --------------------------------------------------
const routes = [
  // ADMIN
  {
    path: "/admin",
   
    meta: { requiresAdmin: true, requiresAuth: true },
    children: [
      {
        path: "dashboard",
        component: () => import("../views/admin/DashboardView.vue"),
        meta: { title: "Admin Dashboard", requiresAdmin: true },
      },
 
    
      {
        path: "adminchat",
        component: () => import("../views/admin/adminchat.vue"),
        meta: { title: "Chat", requiresAdmin: true },
      },
    ],
  },

  // VERIFY OTP
  {
    path: "/verify-otp",
    component: () => import("../views/auth/VerifyOtp.vue"),
    meta: { title: "Verify OTP", requiresAuth: true },
  },

  // CUSTOMER
  {
    path: "/",
    component: () => import("../components/Layouts/customers/IndexLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/customers/LandingPageView.vue"),
        meta: { title: "Home" },
      },
      {
        path: "home",
        component: () => import("../views/customers/LandingPageView.vue"),
        meta: { title: "Home", requiresAuth: true },
      },
      {
        path: "checkout",
        component: () => import("../views/customers/checkout.vue"),
        meta: { title: "Checkout", requiresAuth: true },
      }, {
        path: "profile",
        component: () => import("../views/customers/profile.vue"),
        meta: { title: "Checkout", requiresAuth: true },
      },
    ],
  },

  { path: "/:pathMatch(.*)*", redirect: "/" },
];

// --------------------------------------------------
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// --------------------------------------------------
// FIREBASE AUTH STATE
// --------------------------------------------------
let currentUser: User | null = null;
let authInitialized = false;

onAuthStateChanged(auth, (user) => {
  currentUser = user;
  authInitialized = true;
});

// --------------------------------------------------
// GLOBAL ROUTE GUARD
// --------------------------------------------------
// --------------------------------------------------
// GLOBAL ROUTE GUARD
// --------------------------------------------------
router.beforeEach(async (to, from, next) => {
  document.title = "Thrives - " + (to.meta.title || "Page");

  // wait for firebase auth
  await new Promise<void>((resolve) => {
    const check = () => (authInitialized ? resolve() : setTimeout(check, 50));
    check();
  });

  // requires login
  if (to.meta.requiresAuth && !currentUser) {
    return next("/login");
  }

  if (!currentUser) return next();

  try {
    const db = getFirestore();
    const snap = await getDoc(doc(db, "users", currentUser.uid));

    if (!snap.exists()) return next("/login");

    const { verified, type } = snap.data(); // type: "1" | "2"

    // 🚨 NOT VERIFIED → FORCE OTP
    if (!verified && to.path !== "/verify-otp") {
      return next("/verify-otp");
    }

    // 🚨 VERIFIED BUT STILL ON OTP PAGE
    if (verified && to.path === "/verify-otp") {
      return type === "2" ? next("/admin/dashboard") : next("/home");
    }

    // 🚨 BLOCK NON-ADMIN FROM ADMIN ROUTES
    if (to.meta.requiresAdmin && type !== "2") {
      return next("/admin");
    }

    // 🚨 ADMIN TRYING TO ACCESS CUSTOMER HOME
    if (type === "2" && to.path.startsWith("/home")) {
      return next("/admin/dashboard");
    }

    // 🚨 ALLOW ADMIN TO STAY ON THEIR CURRENT ADMIN ROUTE
    if (type === "2" && to.path.startsWith("/admin")) {
      // do nothing, allow
      return next();
    }

  } catch (err) {
    console.error("Router guard error:", err);
  }

  next();
});


export default router;
